import { render, staticRenderFns } from "./CategoryListItem.vue?vue&type=template&id=2e87c792&scoped=true"
import script from "./CategoryListItem.vue?vue&type=script&lang=js"
export * from "./CategoryListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e87c792",
  null
  
)

export default component.exports